export default __webpack_public_path__ + "static/media/9.0fbf11e2.png";